module.exports = __webpack_public_path__ + "static/media/IMG_0416.d710aca7.HEIC";